import { IDataboundWidget } from "../models";
import { Widget } from "./widget";

export class DataBoundWidget extends Widget implements IDataboundWidget {
    /**
     * Retrieves the data items currently bound to the widget.
     * @returns An array of data items
     */
    dataItems(): any[] {
        const dataSource = (this as any).dataSource;
        if (dataSource && typeof dataSource.view === "function") {
            return dataSource.flatView();
        }
        return [];
    }
}

DataBoundWidget.fn = DataBoundWidget.prototype;

// Re-export types for convenience
export type {
    IDataboundWidget
} from "../models/databound-widget";